<script lang="ts">
  // TODO: render checkbox and dropdown as same column
  import classNames from "../../utils/classNames";
  import CustomIcon from "../CustomIcon.svelte";
  import Checkbox from "./RenderTableLeftActions.svelte";
  import RenderActions from "./RenderActions.svelte";
  import { Column, ColumnMask, Config, ColumnValue } from "./types.svelte";
  import { createEventDispatcher } from "svelte";

  export let dataKey = "id";
  export let row;
  export let columns: Column[] = [];
  export let config: Config;
  export let selectedIds = [];
  export let handleCheckItem;
  export let subTableDataId;
  export let toggleDropdown;

  const defaultMasking = {
    mask: "-",
    values: [null, undefined],
  };
  const dispatch = createEventDispatcher();

  function onColumnClick(column: Column) {
    if (column.renderBy !== "actions" && column.isClickable) {
      dispatch("columnClick", { column, row });
    }
  }

  const maskingFormater =
    (masking: ColumnMask = defaultMasking) =>
    (value: ColumnValue): ColumnValue => {
      if (masking?.values.includes(value)) {
        return masking.mask;
      }
      return value;
    };

  function formatColumn(clmn: Column, value: ColumnValue) {
    const pipe =
      (...fns) =>
      (x) =>
        fns.reduce((v, f) => f(v), x) ?? value;

    if (clmn.renderBy !== "actions") {
      const formats = [];
      if (clmn.formatter) {
        formats.push(clmn.formatter);
      }
      formats.push(maskingFormater(clmn.masking));

      return pipe(...formats)(value);
    }

    return value;
  }
</script>

<tr>
  {#each columns as clmn, idx}
    <td
      class={classNames(
        "border-b bg-white py-4 text-sm px-1.5 table-cell overflow-hidden truncate",
        idx === 0 && config.stickyFirstColumn && "sticky left-0 z-60",
        idx + 1 === columns.length &&
          config.stickyLastColumn &&
          "sticky right-0 z-50",
        clmn.width,
        !config.multilineColumns && "whitespace-nowrap"
      )}
    >
      {#if clmn.renderBy === "image"}
        <img src={row[clmn.dataKey]} alt="" height="auto" width="100" />
      {/if}

      {#if clmn.renderBy === "checkbox"}
        <Checkbox
          isChecked={selectedIds.includes(row[dataKey])}
          on:click={() => handleCheckItem(row[dataKey])}
        />
      {/if}
      {#if clmn.renderBy === "dropdown"}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
          class="flex flex-row align-center max-w-[60px]"
          on:click={() => toggleDropdown(row)}
        >
          <div
            class={subTableDataId === row[dataKey]
              ? "rotate-180 duration-300 ease-in-out"
              : "rotate-0 duration-300 ease-in-out"}
          >
            <CustomIcon
              name="chevron_down"
              color="#9A9AB0"
              title="open/close channels"
              class="h-5 w-5"
            />
          </div>
        </div>
      {/if}
      <!-- {:else} -->
      <div
        style:width={clmn.width ? `${clmn.width}px` : null}
        class={classNames("truncate w-full", idx == 0 && "pl-6")}
      >
        <!--  -->
        {#if clmn.renderBy === "formatter"}
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <span
            title={clmn.formatter?.(row[clmn.dataKey]) || row[clmn.dataKey]}
            class:cursor-pointer={clmn.isClickable}
            class:font-medium={clmn.isClickable}
            on:click={(e) => onColumnClick(clmn)}
          >
            {formatColumn(clmn, row[clmn.dataKey])}
          </span>
        {/if}

        {#if clmn.renderBy === "actions"}
          <RenderActions {row} actions={clmn.actions} on:actionClick />
        {/if}
      </div>
    </td>
  {/each}
</tr>
{#if subTableDataId === row[dataKey]}
  <tr>
    <!-- skip the toggle icon -->
    <!-- <td class="border-b bg-gray-50 min-w-[60px] max-w-[60px]" /> -->
    <td
      colspan={columns.length}
      class="w-full bg-gray-50 border-b overflow-y-auto pl-8"
    >
      <slot name="sub_table" />
    </td>
  </tr>
{/if}
